import { createFileRoute } from '@tanstack/react-router';
import { generateValidateSearch } from '@/lib/filters/validate-search';
import { engagementsFilterConfig } from '@/lib/filters/configs/engagement-filters';

// Was `(search) => search`, which accepts anything and validates nothing. The filter params are
// now declared, so the router keeps them across navigations and rejects values the dropdowns
// cannot produce (W4.T6.0).
export const Route = createFileRoute('/engagements/')({
  validateSearch: generateValidateSearch(engagementsFilterConfig),
});
